"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Contact = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _socialIcons = require("@ori-ui/social-icons");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Contact = ({
  contact,
  type
}) => {
  if (!contact) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [type === 'email' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Email, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
        href: `mailto:${contact}`,
        children: contact
      })]
    }) : null, type === 'phone' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Telephone, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
        href: `tel:${contact}`,
        children: contact
      })]
    }) : null, type === 'whatsApp' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_socialIcons.Whatsapp, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link
      // The replaceAll(/\D/g, '') method removes all non-digit characters from contact
      // (where \D matches any character that is not a digit), ensuring that only numbers remain.
      // This is important because WhatsApp's URL format requires a phone number without spaces,
      // dashes, or other symbols.
      // For example, if contact is "123-456-7890", the expression will produce https://wa.me/1234567890.
      // This URL can be used to open a chat with the specified number in WhatsApp. This approach helps
      // prevent errors due to formatting issues and ensures compatibility with WhatsApp's requirements.
      // The replace(/^0+/, '') method removes any leading zeros from the phone number as required by WhatsApp.
      , {
        href: `https://wa.me/${contact.replaceAll(/\D/g, '').replace(/^0+/, '')}`,
        target: "_blank",
        rel: "noopener noreferrer",
        children: contact
      })]
    }) : null]
  });
};
exports.Contact = Contact;
